import { gql } from "@apollo/client";

export const USER_SITES = gql`
  query SiteManager_Sites($n: Int!, $after: String, $where: InputChargeSiteOperators) {
    sites(n: $n, after: $after, where: $where) @connection(key: "siteManagerSites") {
      edges {
        cursor
        node {
          account
          active
          optimisationStrategy
          solarStrategy
          feeds
          id
          name
          ref
          serials
          site_limit_kw
          site_limit
        }
      }
      totalCount
    }
  }
`;

export const CHARGER_DETAILS = gql`
  query SiteManager_Charger_details($n: Int, $after: String, $where: InputSalesforceChargerOperators) {
    chargers(n: $n, after: $after, where: $where) @connection(key: "siteManagerChargerDetails") {
      edges {
        cursor
        node {
          serial
          salesforce_details: salesforce_details {
            id
            name
            circuit_amp_limit
            session_limit
            last_comms
            manufacturer
            model
            ocpp_status
            evos_custom_status
            ocpp_firmware_status
          }
          details: salesforce_details {
            id
            name
            circuit_amp_limit
            session_limit
            last_comms
            manufacturer
            model
            ocpp_status
            evos_custom_status
            ocpp_firmware_status
          }
        }
      }
    }
  }
`;

export const CHARGER_LOADS = gql`
  query SiteManager_Charger_loads(
    $chargers_n: Int
    $chargers_after: String
    $chargers_where: InputSalesforceChargerOperators
    $transactions_n: Int
    $transactions_where: InputTransactionDataOperators
  ) {
    chargers(n: $chargers_n, after: $chargers_after, where: $chargers_where) @connection(key: "siteManagerChargerLoads") {
      edges {
        cursor
        node {
          serial
          transactions(n: $transactions_n, where: $transactions_where) {
            edges {
              node {
                serial
                meterStop
                meterValues {
                  CurrentImportL1
                  CurrentImportL2
                  CurrentImportL3
                  CurrentOffered
                  SoC
                  timestamp
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const SITE_PHASE_CURRENT = gql`
  query SiteManager_Site_phase_current($input_ids: [String]!, $site_ref: String!) {
    HistoricalDataContainer @connection(key: "siteManagerPhaseCurrent") {
      power_input_data(input_ids: $input_ids, site_ref: $site_ref) {
        input_id
        data
      }
    }
  }
`;

export const SET_VOLTAGE_OUTPUT = gql`
  mutation SiteManager_Set_voltage_output($device_id: String!, $site_ref: String!, $limit: Int!) {
    set_voltage_output(device_id: $device_id, site_ref: $site_ref, limit: $limit) {
      edges {
        node {
          id
          ref
          feeds
        }
      }
    }
  }
`;

export const SET_SESSION_LIMIT = gql`
  mutation SiteManager_Set_session_limit($charge: Int!, $serial: String!) {
    set_session_limit(charge: $charge, serial: $serial) {
      edges {
        node {
          salesforce_details: salesforce_details {
            id
            session_limit
            circuit_amp_limit
          }
        }
      }
    }
  }
`;

export const SET_MANAGEMENT_STRATEGY = gql`
  mutation SiteManager_Set_management_strategy($device_id: String!, $site_ref: String!, $strategy: SiteStrategy!) {
    set_management_strategy(device_id: $device_id, site_ref: $site_ref, strategy: $strategy) {
      edges {
        node {
          id
          ref
          feeds
          optimisationStrategy
        }
      }
    }
  }
`;

export const SET_SOLAR_STRATEGY = gql`
  mutation SiteManager_Set_solar_strategy($site_ref: String!, $strategy: SolarStrategy!) {
    set_solar_strategy(site_ref: $site_ref, strategy: $strategy) {
      edges {
        node {
          id
          ref
          feeds
          solarStrategy
        }
      }
    }
  }
`;
